import React, {
    useEffect,
    useState,
} from "react";

import axios from "axios";
import moment from "moment";

import {
    MdClose,
} from "react-icons/md";

import {
    FiActivity,
} from "react-icons/fi";

import { useSelector } from "react-redux";

import Config from "../../Config";
import { ModalContainer, ModalContent, ScrollableContent } from "../Styles/InputStyles";
import DrawerHeader from "../Common/DrawerHeader";


const ActivityLogsModal = ({
    onClose,
}) => {
    const user = useSelector(
        (state) => state.UserReducer.user
    );

    const [startDate] = useState(
        moment()
            .startOf("month")
            .format("YYYY-MM-DD")
    );

    const [endDate] = useState(
        moment()
            .endOf("month")
            .format("YYYY-MM-DD")
    );

    const [loading, setLoading] = useState(false);

    const [activities, setActivities] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");

    const [filterType, setFilterType] = useState("");


    const fetchActivities =
        async () => {
            try {
                setLoading(true);
                let query =
                    `startDate=${startDate}` +
                    `&endDate=${endDate}` +
                    `&s=${searchQuery}` +
                    `&t=${filterType}` +
                    `&propId=0`;

                const response =
                    await axios.get(
                        `${Config.apiUrl}/activity-log/list?${query}`,
                        {
                            headers: {
                                authorization:
                                    "Bearer " +
                                    user.token,

                                "Content-Type":
                                    "application/x-www-form-urlencoded; charset=UTF-8",
                            },
                        }
                    );

                setActivities(
                    response?.data?.data || []
                );
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

    useEffect(() => {
        fetchActivities();
    }, [
        searchQuery,
        filterType,
        startDate,
        endDate,
    ]);

    const groupedActivities =
        activities.reduce(
            (acc, item) => {
                const date =
                    moment(
                        item.createdAt
                    ).format(
                        "DD MMM YYYY"
                    );
                if (!acc[date]) {
                    acc[date] = [];
                }
                acc[date].push(item);
                return acc;
            },
            {}
        );

    return (
        <ModalContainer>

            <DrawerHeader
                title="Recent Activity"
                subtitle="Operational activity logs"
                icon={<FiActivity />}
                onClose={onClose}
            />

            {/* Body */}
            <ModalContent className='py-2'>
                <ScrollableContent className="max-h-[calc(100dvh-100px)]">
                    {loading ? (
                        <div
                            className="h-full min-h-full flex flex-col justify-center px-5"
                        >
                            <div className="space-y-5 animate-pulse w-full">

                                {[1, 2, 3, 4, 5].map(
                                    (item) => (
                                        <div
                                            key={item}
                                            className="flex gap-4"
                                        >
                                            {/* Timeline Dot */}
                                            <div className="relative pt-2">
                                                <div
                                                    className="w-2.5 h-2.5 rounded-full bg-gray-300"
                                                />

                                                <div
                                                    className="absolute left-[4px] top-5 h-16 w-px bg-gray-200"
                                                />
                                            </div>

                                            {/* Card */}
                                            <div className="flex-1">
                                                <div
                                                    className="bg-[#F8FAFC] rounded-2xl p-4"
                                                >
                                                    <div className="h-4 w-3/4 bg-gray-200 rounded-md" />

                                                    <div className="h-3 w-1/3 bg-gray-100 rounded-md mt-3" />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    ) : activities.length === 0 ? (
                        <div className="absolute inset-0 flex flex-col items-center justify-center">
                            <FiActivity className="text-5xl text-gray-300" />
                            <p className="mt-4 text-sm text-gray-500">
                                No activity found
                            </p>
                        </div>
                    ) : (
                        <div className="px-6 space-y-8 mt-4">
                            {Object.entries(
                                groupedActivities
                            ).map(
                                ([date, items]) => (
                                    <div key={date}>
                                        {/* Date */}
                                        <div
                                            className="sticky top-0 z-10 bg-white py-2"
                                        >
                                            <span
                                                className="text-xs font-semibold tracking-wide uppercase text-gray-400"
                                            >
                                                {date}
                                            </span>
                                        </div>

                                        {/* Timeline */}
                                        <div className="space-y-5 mt-3">

                                            {items.map(
                                                (
                                                    item,
                                                    index
                                                ) => (
                                                    <div
                                                        key={
                                                            item.id ||
                                                            index
                                                        }
                                                        className="flex gap-4"
                                                    >

                                                        {/* Dot */}
                                                        <div className="relative">
                                                            <div
                                                                className="w-2.5 h-2.5 rounded-full
                              bg-[#0078BD] mt-2"
                                                            />

                                                            <div
                                                                className="absolute left-[4px]
                              top-5 bottom-[-30px]
                              w-px bg-gray-200"
                                                            />
                                                        </div>

                                                        {/* Content */}
                                                        <div className="flex-1 pb-2">

                                                            <div
                                                                className="bg-[#F8FAFC]
                              rounded-2xl p-4"
                                                            >
                                                                <p className="text-sm text-gray-800 leading-relaxed">

                                                                    <span className="font-semibold">
                                                                        {item?.doneByName ||
                                                                            "--"}
                                                                    </span>{" "}

                                                                    {item?.description ||
                                                                        "--"}
                                                                </p>

                                                                <div
                                                                    className="flex items-center gap-2
                                mt-2 text-xs text-gray-500"
                                                                >
                                                                    <span>
                                                                        {item?.device ===
                                                                            Config.PLATFORM
                                                                                .ANDROID
                                                                            ? "Android"
                                                                            : item?.device ===
                                                                                Config.PLATFORM
                                                                                    .IOS
                                                                                ? "iOS"
                                                                                : "Web"}
                                                                    </span>

                                                                    <span>
                                                                        •
                                                                    </span>

                                                                    <span>
                                                                        {moment(
                                                                            item.createdAt
                                                                        ).fromNow()}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    </div>
                                )
                            )}
                        </div>
                    )}
                </ScrollableContent>
            </ModalContent>
        </ModalContainer>
    );
};

export default ActivityLogsModal;